import axios from "axios";
import { baseAddress } from "../../../tools/baseAddress";
let addressGetSystemInfo = baseAddress + "get_system_info_for_table";
let addressEditSystem = baseAddress + "edit_system";

export const editSystem = (systemName, csvMagnetic, csvAcoustic, csvSeismic, archive, moreInfo, moreInfoProject, plot_settings) => {
    var formData = new FormData();
    formData.append("magneticCsv", csvMagnetic);
    formData.append("acousticCsv", csvAcoustic);
    formData.append("seismicCsv", csvSeismic);
    formData.append("archive", archive);
    formData.append("token", localStorage.getItem("token"))
    formData.append("system_key", systemName)
    if (moreInfo !== null) {
        formData.append("moreInfo", moreInfo)
        formData.append("moreInfoProject", JSON.stringify(moreInfoProject))
    }
    
    if (plot_settings) {
        formData.append("plotSettings", JSON.stringify(plot_settings));
    }
    
    return axios
        .post(addressEditSystem, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
        .then(response => {
            return response;
        })
        .catch(err => {
            console.error('Edit system error:', err);
            if (err.response === undefined || err.response?.status === 500) {
                return { data: "Internal server error! Please try again.", status: 500 };
            }
            return err.response;
        });
}

export const sortObjectByKeys = (keysArray, object) => {
    let sortedKeys = {}, i, j, stop = 0;
    const len = keysArray.length;
    
    // Make a copy of the array to avoid modifying the original
    let workingArray = [...keysArray];
    
    for (i = 0; i < len; i++) {
        let smallestIndex = 0,
            smallestKey = workingArray[0],
            smallestValue = extractNumericValue(workingArray[0]);
            
        for (j = 0; j < len - stop; j++) {
            let currentValue = extractNumericValue(workingArray[j]);
            if (currentValue < smallestValue) {
                smallestIndex = j;
                smallestKey = workingArray[j];
                smallestValue = currentValue;
            }
        }
        sortedKeys[smallestKey] = object[smallestKey];
        workingArray.splice(smallestIndex, 1);
        stop++;
    }
    return sortedKeys;
}

// Helper function to extract numeric value from keys like "1kV", "2.5mm", "10mm"
const extractNumericValue = (key) => {
    if (key.includes('kV')) {
        return parseFloat(key.replace('kV', ''));
    }
    if (key.includes('mm')) {
        return parseFloat(key.replace('mm', ''));
    }
    return parseFloat(key);
}

export const getSystemInfo = (systemName) => {
    return axios
        .post(addressGetSystemInfo,
            {
                token: localStorage.getItem("token"),
                system_key: systemName
            })
        .then(response => {
            return response;
        })
        .catch(err => {
            console.error('Get system info error:', err);
            return err.response;
        });
}

export const sortMagnification = (keysArray, object, len) => {
    let sortedKeys = {}, i, j, stop = 0;
    for (i = 0; i < len; i++) {
        let splitSmallesValue = keysArray[0].split(' ', 3)[2];
        let smallestIndex = 0,
            smallestKey = keysArray[0],
            smallestValue = splitSmallesValue.substring(0, splitSmallesValue.length - 1);
        for (j = 0; j < len - stop; j++) {
            let splitValue = keysArray[j].split(' ', 3)[2];
            let value = splitValue.substring(0, splitValue.length - 1);
            if (parseInt(value) < parseInt(smallestValue)) {
                smallestIndex = j;
                smallestKey = keysArray[j];
                smallestValue = value;
            }
        }
        sortedKeys[smallestKey] = object[smallestKey];
        keysArray.splice(smallestIndex, 1);
        stop++;
    }
    return sortedKeys;
}